import styled from 'styled-components';

import { styledReset } from '@pkg/primitives';

import { tokens } from '../../tokens';

export const StyledBar = styled.ol`
    ${styledReset.list};
    display: flex;
    flex: 1 1 auto;
    // If we ever want to go smaller than this,
    // we could convert this to a CSS var.
    min-height: ${tokens.bar.minHeight}px;
`;
